import { createSlice } from "@reduxjs/toolkit";

import { SIModalData, SIModalSliceState, SIStoreState } from "./store.interface";

const initialState: SIModalSliceState = {
    active: []
};

const ModalSlice = createSlice({
    name: "modals",
    initialState,
    reducers: {
        openModal: (state, action) => {
            const { name, data } = action.payload as SIModalData;
            const isModalActive = state.active.some(modal => modal.name === name);

            if (!isModalActive) {
                state.active.push({ name, data });
            }
        },
        closeModal: (state, action) => {
            const name = action.payload;
            state.active = state.active.filter(modal => modal.name !== name);
        },
        closeAllModals: (state) => {
            state.active = [];
        },
    },
});

export const { openModal, closeModal, closeAllModals } = ModalSlice.actions;
export default ModalSlice.reducer;

// Selectors
export const getActiveModals = () => (state: SIStoreState) => state.modals.active;
export const isModalActive = (name: string) => (state: SIStoreState) =>
    state.modals.active.some(modal => modal.name === name);
export const getModalData = (name: string) => (state: SIStoreState) =>
    state.modals.active.find(modal => modal.name === name)?.data ?? null;